// extracted by mini-css-extract-plugin
module.exports = {"select-wrapper":"Select_select-wrapper__9L5es","select":"Select_select__mgpmq","icon":"Select_icon__3xTWA"};